module.exports = __webpack_public_path__ + "img/bespoke123_03.122c8ad7.jpg";